'use client';
import React, { useState } from 'react';

export default function AnnouncementBar() {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div
      className="relative text-center"
      style={{
        backgroundColor: '#1A2332',
        padding: '10px 48px',
        fontFamily: 'adobe-garamond-pro, Georgia, serif',
        fontSize: '13px',
        letterSpacing: '0.06em',
        color: 'rgba(245,240,234,0.75)',
      }}
    >
      <style>{`
        .announcement-link {
          color: rgba(245,240,234,0.75);
          text-decoration: none;
          transition: color 0.2s ease;
        }
        .announcement-link:hover {
          color: #F5F0EA;
        }
      `}</style>
      <a href="/contact" className="announcement-link">
        Now accepting new clients &mdash;{' '}
        <span style={{ borderBottom: '1px solid rgba(245,240,234,0.4)', paddingBottom: '1px' }}>
          arrange a confidential consultation
        </span>
      </a>
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-4 top-1/2 -translate-y-1/2"
        aria-label="Close"
        style={{
          background: 'none',
          border: 'none',
          color: 'rgba(245,240,234,0.4)',
          fontSize: '16px',
          cursor: 'pointer',
          lineHeight: 1,
          padding: '4px',
        }}
      >
        ×
      </button>
    </div>
  );
}
